import instance from "./base";
const CHARGING_URL =  "https://www.nnjtny.com/charging"
// const CHARGING_URL =  "http://172.16.8.209:8012/charging"
export function login(username,password,code,uuid){
    const data = {username,password,code,uuid}
    return instance({
        url: CHARGING_URL +'/pc/platform/statistics/largeScreen/login',
        headers:{
            isToken: false
        },
        method: 'post',
        params: data
    })
}

export function getCodeImage(){
    return instance({
        url: CHARGING_URL + '/pc/platform/statistics/largeScreen/getCode',
        headers:{
            isToken :false
        },
        method: 'get',
        timeout: 20000
    })
}